/* eslint-disable max-lines */
/* eslint-disable react/jsx-key */
import React, { useState } from "react";

import { Row } from "@gamedev-web/gamedev-sdk-core";
import { IconText } from "@gaming/xds-react-js";
import { ChevronDown, ChevronRight } from "@gaming/xds-react-js-icons";

import { useString } from "../../../localization/localizationHelpers";
import {
  AaaGameInformationAvailabilityDataType,
  AaaGameInformationConceptDetailsDataType,
  AaaGameInformationConfigurationsDataType,
  AaaGameInformationDistributionInformationDataType,
  AaaGameInformationGameExpectationsDataType,
  AaaGameInformationSupplementaryDataType,
  AaaGameInformationTechnicalCapabilitiesDataType,
  AaaGameInformationUgcDataType,
  AaaGameInformationXboxNetworkDataType,
  AaaIntroContactDataType,
  AaaIntroStudioDataType,
  CommonIntroContactDataType,
  CommonIntroShippingDataType,
  GameInformationConceptDetailsDataType,
  GameInformationConfigurationsDataType,
  GameInformationGameExpectationsDataType,
  GameInformationPricingAndAvailabilityDataType,
  GameInformationSupplementaryDataType,
  GameInformationTechnicalCapabilitiesDataType,
  GameInformationUgcDataType,
  GameInformationXboxNetworkDataType,
  IdXboxIntroBusinessContactCustomerDataType,
  IdXboxIntroContactDataType,
  IdXboxIntroShippingDataType,
  IdXboxIntroStudioDataType,
  IntroBusinessContactCustomerDataType,
  PitchInformationAboutYourGameDataType,
  PitchInformationAboutYourselfDataType,
  PitchInformationAskForXboxDataType,
  PitchInformationPublisherDeveloperDataType,
} from "../../../models/forms";
import {
  ReadOnlyAaaAvailability,
  ReadOnlyAaaConceptDetail,
  ReadOnlyAaaConfigurations,
  ReadOnlyAaaContact,
  ReadOnlyAaaDistributionInformation,
  ReadOnlyAaaGameExpectations,
  ReadOnlyAaaSupplementaryData,
  ReadOnlyAaaTechnicalCapabilities,
  ReadOnlyAaaUgc,
  ReadOnlyAaaXboxNetwork,
} from "./Aaa";
import { ReadOnlyAaaStudio } from "./Aaa/ReadOnlyAaaStudio";
import * as styles from "./ApplicationInformationRow.module.css";
import {
  ReadOnlyIdXboxAvailabilityPricing,
  ReadOnlyIdXboxConceptDetail,
  ReadOnlyIdXboxConfigurations,
  ReadOnlyIdXboxGameExpectations,
  ReadOnlyIdXboxSupplementaryData,
  ReadOnlyIdXboxTechnicalCapabilities,
  ReadOnlyIdXboxUgc,
  ReadOnlyIdXboxXboxNetwork,
} from "./IdXbox";
import {
  ReadOnlyPitchAboutYourGame,
  ReadOnlyPitchAboutYourself,
  ReadOnlyPitchAskForXbox,
  ReadOnlyPitchPublisherDeveloper,
} from "./Pitch";
import { ReadOnlyContact, ReadOnlyShipping, ReadOnlyStudio } from "./Shared";
import { ReadOnlyBusinessContactCustomer } from "./Shared/ReadOnlyBusinessContactCustomer";

export type FormPreviewValidDataType =
  | GameInformationConceptDetailsDataType
  | GameInformationGameExpectationsDataType
  | GameInformationPricingAndAvailabilityDataType
  | GameInformationTechnicalCapabilitiesDataType
  | GameInformationConfigurationsDataType
  | GameInformationXboxNetworkDataType
  | GameInformationUgcDataType
  | GameInformationSupplementaryDataType
  | IdXboxIntroContactDataType
  | IdXboxIntroShippingDataType
  | IdXboxIntroBusinessContactCustomerDataType
  | IdXboxIntroStudioDataType
  | PitchInformationPublisherDeveloperDataType
  | PitchInformationAboutYourGameDataType
  | PitchInformationAskForXboxDataType
  | PitchInformationAboutYourselfDataType
  | AaaIntroContactDataType
  | AaaIntroStudioDataType
  | AaaGameInformationConceptDetailsDataType
  | AaaGameInformationDistributionInformationDataType
  | AaaGameInformationGameExpectationsDataType
  | AaaGameInformationAvailabilityDataType
  | AaaGameInformationTechnicalCapabilitiesDataType
  | AaaGameInformationConfigurationsDataType
  | AaaGameInformationXboxNetworkDataType
  | AaaGameInformationUgcDataType
  | AaaGameInformationSupplementaryDataType;

export enum ReadOnlyFormId {
  IdXboxConceptDetails = "IdXboxConceptDetails",
  IdXboxGameExpectations = "IdXboxGameExpectations",
  IdXboxPricingAndAvailability = "IdXboxPricingAndAvailability",
  IdXboxTechnicalCapabilities = "IdXboxTechnicalCapabilities",
  IdXboxConfigurations = "IdXboxConfigurations",
  IdXboxXboxNetwork = "IdXboxXboxNetwork",
  IdXboxUgc = "IdXboxUgc",
  IdXboxSupplementaryData = "IdXboxSupplementaryData",
  IdXboxContactInformation = "IdXboxContactInformation",
  IdXboxShippingInformation = "IdXboxShippingInformation",
  IdXboxBusinessContactCustomerInformation = "IdXboxBusinessContactCustomerInformation",
  IdXboxStudioInformation = "IdXboxStudioInformation",
  PitchPublisherDeveloperInformation = "PitchPublisherDeveloperInformation",
  PitchAboutYourGame = "PitchAboutYourGame",
  PitchAskForXbox = "PitchAskForXbox",
  PitchAboutYourself = "PitchAboutYourself",
  AaaContactInformation = "AaaContactInformation",
  AaaShippingInformation = "AaaShippingInformation",
  AaaStudioInformation = "AaaStudioInformation",
  AaaConceptDetails = "AaaConceptDetails",
  AaaDistributionInformation = "AaaDistributionInformation",
  AaaGameExpectations = "AaaGameExpectations",
  AaaAvailability = "AaaAvailability",
  AaaTechnicalCapabilities = "AaaTechnicalCapabilities",
  AaaConfigurations = "AaaConfigurations",
  AaaXboxNetwork = "AaaXboxNetwork",
  AaaUgc = "AaaUgc",
  AaaSupplementaryData = "AaaSupplementaryData",
}

export type ApplicationInformationRowProps = {
  formId: ReadOnlyFormId;
  dataInForm: FormPreviewValidDataType;
};

type ReadOnlyFormConfig = {
  title: string;
  getForm: (_dataInForm: FormPreviewValidDataType) => JSX.Element;
};

const mapWithFormRows = new Map<ReadOnlyFormId, ReadOnlyFormConfig>([
  [
    ReadOnlyFormId.IdXboxConceptDetails,
    {
      title: "gameInformationConceptDetailsTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyIdXboxConceptDetail
          dataInForm={dataInForm as GameInformationConceptDetailsDataType}
        />
      ),
    },
  ],
  [
    ReadOnlyFormId.IdXboxGameExpectations,
    {
      title: "gameInformationGameExpectationsTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyIdXboxGameExpectations
          dataInForm={dataInForm as GameInformationGameExpectationsDataType}
        />
      ),
    },
  ],
  [
    ReadOnlyFormId.IdXboxPricingAndAvailability,
    {
      title: "gameInformationPricingAndAvailabilityTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyIdXboxAvailabilityPricing
          dataInForm={dataInForm as GameInformationPricingAndAvailabilityDataType}
        />
      ),
    },
  ],
  [
    ReadOnlyFormId.IdXboxTechnicalCapabilities,
    {
      title: "gameInformationTechnicalCapabilitiesTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyIdXboxTechnicalCapabilities
          dataInForm={dataInForm as GameInformationTechnicalCapabilitiesDataType}
        />
      ),
    },
  ],
  [
    ReadOnlyFormId.IdXboxConfigurations,
    {
      title: "gameInformationConfigurationsTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyIdXboxConfigurations
          dataInForm={dataInForm as GameInformationConfigurationsDataType}
        />
      ),
    },
  ],
  [
    ReadOnlyFormId.IdXboxXboxNetwork,
    {
      title: "gameInformationXboxNetworkTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyIdXboxXboxNetwork dataInForm={dataInForm as GameInformationXboxNetworkDataType} />
      ),
    },
  ],
  [
    ReadOnlyFormId.IdXboxUgc,
    {
      title: "gameInformationUgcTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyIdXboxUgc dataInForm={dataInForm as GameInformationUgcDataType} />
      ),
    },
  ],
  [
    ReadOnlyFormId.IdXboxSupplementaryData,
    {
      title: "gameInformationSupplementaryDataTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyIdXboxSupplementaryData
          dataInForm={dataInForm as GameInformationSupplementaryDataType}
        />
      ),
    },
  ],
  [
    ReadOnlyFormId.IdXboxContactInformation,
    {
      title: "introContactInformationTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyContact dataInForm={dataInForm as CommonIntroContactDataType} />
      ),
    },
  ],
  [
    ReadOnlyFormId.IdXboxShippingInformation,
    {
      title: "introShippingInformationTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyShipping dataInForm={dataInForm as CommonIntroShippingDataType} />
      ),
    },
  ],
  [
    ReadOnlyFormId.IdXboxBusinessContactCustomerInformation,
    {
      title: "businessContactDetailsForCustomersTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyBusinessContactCustomer
          dataInForm={dataInForm as IntroBusinessContactCustomerDataType}
        />
      ),
    },
  ],
  [
    ReadOnlyFormId.IdXboxStudioInformation,
    {
      title: "introStudioInformationTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyStudio dataInForm={dataInForm as IdXboxIntroStudioDataType} />
      ),
    },
  ],
  [
    ReadOnlyFormId.PitchPublisherDeveloperInformation,
    {
      title: "pitchInformationPublisherDeveloperInformationTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyPitchPublisherDeveloper
          dataInForm={dataInForm as PitchInformationPublisherDeveloperDataType}
        />
      ),
    },
  ],
  [
    ReadOnlyFormId.PitchAboutYourGame,
    {
      title: "pitchInformationAboutYourGameTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyPitchAboutYourGame
          dataInForm={dataInForm as PitchInformationAboutYourGameDataType}
        />
      ),
    },
  ],
  [
    ReadOnlyFormId.PitchAskForXbox,
    {
      title: "pitchInformationAskForXboxTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyPitchAskForXbox dataInForm={dataInForm as PitchInformationAskForXboxDataType} />
      ),
    },
  ],
  [
    ReadOnlyFormId.PitchAboutYourself,
    {
      title: "pitchInformationAboutYourselfTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyPitchAboutYourself
          dataInForm={dataInForm as PitchInformationAboutYourselfDataType}
        />
      ),
    },
  ],
  [
    ReadOnlyFormId.AaaContactInformation,
    {
      title: "introContactInformationTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyAaaContact dataInForm={dataInForm as CommonIntroContactDataType} />
      ),
    },
  ],
  [
    ReadOnlyFormId.AaaStudioInformation,
    {
      title: "introStudioInformationTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyAaaStudio dataInForm={dataInForm as AaaIntroStudioDataType} />
      ),
    },
  ],
  [
    ReadOnlyFormId.AaaConceptDetails,
    {
      title: "aaaGameInformationConceptDetailsTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyAaaConceptDetail
          dataInForm={dataInForm as AaaGameInformationConceptDetailsDataType}
        />
      ),
    },
  ],
  [
    ReadOnlyFormId.AaaDistributionInformation,
    {
      title: "aaaGameInformationDistributionInformationTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyAaaDistributionInformation
          dataInForm={dataInForm as AaaGameInformationDistributionInformationDataType}
        />
      ),
    },
  ],
  [
    ReadOnlyFormId.AaaGameExpectations,
    {
      title: "aaaGameInformationGameExpectationsTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyAaaGameExpectations
          dataInForm={dataInForm as AaaGameInformationGameExpectationsDataType}
        />
      ),
    },
  ],
  [
    ReadOnlyFormId.AaaAvailability,
    {
      title: "aaaGameInformationAvailabilityTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyAaaAvailability
          dataInForm={dataInForm as AaaGameInformationAvailabilityDataType}
        />
      ),
    },
  ],
  [
    ReadOnlyFormId.AaaTechnicalCapabilities,
    {
      title: "aaaGameInformationTechnicalCapabilitiesTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyAaaTechnicalCapabilities
          dataInForm={dataInForm as AaaGameInformationTechnicalCapabilitiesDataType}
        />
      ),
    },
  ],
  [
    ReadOnlyFormId.AaaConfigurations,
    {
      title: "aaaGameInformationConfigurationsTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyAaaConfigurations
          dataInForm={dataInForm as AaaGameInformationConfigurationsDataType}
        />
      ),
    },
  ],
  [
    ReadOnlyFormId.AaaXboxNetwork,
    {
      title: "aaaGameInformationXboxNetworkTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyAaaXboxNetwork dataInForm={dataInForm as AaaGameInformationXboxNetworkDataType} />
      ),
    },
  ],
  [
    ReadOnlyFormId.AaaUgc,
    {
      title: "aaaGameInformationUgcTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyAaaUgc dataInForm={dataInForm as AaaGameInformationUgcDataType} />
      ),
    },
  ],
  [
    ReadOnlyFormId.AaaSupplementaryData,
    {
      title: "aaaGameInformationSupplementaryDataTitle",
      getForm: (dataInForm: FormPreviewValidDataType) => (
        <ReadOnlyAaaSupplementaryData
          dataInForm={dataInForm as AaaGameInformationSupplementaryDataType}
        />
      ),
    },
  ],
]);

export const ApplicationInformationRow = ({
  formId,
  dataInForm,
}: ApplicationInformationRowProps) => {
  const [showAnswer, setShowAnswer] = useState(false);
  const toggleShowAnswer = () => setShowAnswer(!showAnswer);

  const formConfig = mapWithFormRows.get(formId);
  const title = useString(formConfig?.title ?? "");
  if (!hasValidData(dataInForm) || !formConfig) {
    return null;
  }

  return (
    <Row
      className={styles.applicationInformationRow}
      onClick={toggleShowAnswer}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onKeyDown={(e: any) => e.key === "Enter" && toggleShowAnswer()}
      tabIndex={0}
      role="button"
      aria-expanded={showAnswer ? "true" : "false"}
    >
      <div className={styles.row}>
        <div>
          <IconText icon={showAnswer ? ChevronDown : ChevronRight} label={title ?? ""} />
        </div>
        {showAnswer ? formConfig.getForm(dataInForm) ?? null : null}
      </div>
    </Row>
  );
};

const hasValidData = (dataInForm: { [s: string]: unknown } | ArrayLike<unknown>) =>
  Object.values(dataInForm).reduce(
    (previousValue, currentValue) => previousValue || hasValue(currentValue),
    false
  );

const hasValue = (data: unknown) => {
  // Boolean values, by itself, has nothing to show to the user
  if (typeof data === "boolean") {
    return false;
  }
  // Null or undefined values, are empty values
  if (!data) {
    return false;
  }
  // Arrays with data need to validate the data
  if (Array.isArray(data) && data.length > 0) {
    const internalValue = data.reduce(
      (previousValue, currentValue) => previousValue || hasValue(currentValue),
      false
    );
    if (!internalValue) {
      return false;
    }
  }
  // Objects need to be validated
  if (typeof data === "object") {
    // Objects with no keys are empty
    if (Object.keys(data)?.length === 0) {
      return false;
    }
    // Objects with the selected property are conditional to that value to be true
    const validationKey = "selected";
    if (validationKey in data && !data[validationKey]) {
      return false;
    }
  }
  // Validate Strings, numbers or empty arrays
  if (Number(data) === 0) {
    return false;
  }
  // Any other value is valid
  return true;
};
